/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import React, { useState, useEffect } from "react"
import { Paper, TableRow, TableCell, Tooltip } from "@material-ui/core"
import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Loading,
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  Title,
} from "App/Component/ui"

import { STYLE_DEFAULT_MASTER } from "App/constants/theme"

import { useDatatables, useDatatablesServerSide, useHeadTarif } from "App/hooks"
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  scrollToTop,
} from "App/utils/helpers"
import {
  FormJasa,
  headCells,
  deleteJasaById,
  RESET_STATE_JASA,
  FieldFormTarif,
  ModalJasaDokter,
  FormFilterJasa,
  getByFilterJenisHarga,
  RESET_STATE_FORM_FILTER,
} from "./ui"
import { pushJasaTarif } from "../helperMasterPenjualan"
import { getAllTarif } from "../../Tarif/helpers"
import { FreezeTable } from "components/organism"
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined"
import ModalJasaSpesialis from "./ui/ModalJasaSpesialis"

export default function Jasa() {
  const classes = STYLE_DEFAULT_MASTER()

  const [formData, setFormData] = useState(RESET_STATE_JASA)
  const [rows, setRows] = useState([])
  const { dynamicHead, dataTarif } = useHeadTarif({
    data: headCells,
  })
  const [jasaID, setJasaID] = useState("")
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const [fieldTarif, setFieldTarif] = useState([])
  const [formHargaTarifBeli, setFormHargaTarifBeli] = useState([])
  const [resetFormHargaTarifBeli, setResetFormHargaTarifBeli] = useState([])
  const [formHargaTarifJual, setFormHargaTarifJual] = useState([])
  const [resetFormHargaTarifJual, setResetFormHargaTarifJual] = useState([])
  const [showModalJasaDokter, setShowModalJasaDokter] = useState(false)
  const [showModalJasaSpesialis, setShowModalJasaSpesialis] = useState(false)

  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)

  const setVal = (row) => {
    setJasaID(row.id)
    setFormData({
      id_jenis_jasa: row.id_jenis_jasa,
      id_tarif_cbg: row.id_tarif_cbg,
      tarif_cbg: isNull(row.namaTarifCbg)
        ? "Pilih Tarif CBG"
        : row.namaTarifCbg,
      nama: row?.nama,
      harga: row?.harga,
      status: row?.status,
      id_jenis_harga: formFilter.id_jenis_harga,

      is_emr: row.is_emr,
      is_rajal: row.is_rajal,
      is_ranap: row.is_ranap,
      is_igd: row.is_igd,
      is_perawat: row.is_perawat,
      id_template: row.id_template,
      nama_template: row.nama_template,
      kode_snomed: isNull(row.kode_snomed)
        ? null
        : { value: row.kode_snomed, label: row.kode_snomed },
    })

    const valueTarifBeli = []
    const valueTarifJual = []

    row.harga.map((e) => {
      valueTarifBeli.push({
        id: e.id,
        id_tarif: e.id_tarif,
        harga_beli: e.harga_beli,
        harga_beli2: formatNumber(e.harga_beli),
      })

      valueTarifJual.push({
        id: e.id,
        id_tarif: e.id_tarif,
        harga_jual: e.harga_jual,
        harga_jual2: formatNumber(e.harga_jual),
      })
    })

    setFormHargaTarifBeli(valueTarifBeli)
    setFormHargaTarifJual(valueTarifJual)
  }

  const setFormValues = (res) => {
    const { dataTarif, dataFormTarifBeli, dataFormTarifJual } =
      pushJasaTarif(res)
    setFieldTarif(dataTarif)
    setResetFormHargaTarifBeli(dataFormTarifBeli)
    setResetFormHargaTarifJual(dataFormTarifJual)
  }

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)
    const res = await getByFilterJenisHarga(formFilter, pages, limit)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  async function deleteList() {
    const res = await deleteJasaById(jasaID)
    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
      setJasaID("")
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  useEffect(() => {
    ;(async () => {
      const res = await getAllTarif()
      setFormValues(res)
    })()
  }, [])

  useEffect(() => {
    if (!isNull(formFilter.id_jenis_harga)) {
      setNewData()
    }
  }, [])

  const handleClickSelect = (row) => {
    setShowModalJasaDokter(!showModalJasaDokter)
    setJasaID(row.id)
  }

  const handleClickSpesialis = (row) => {
    setShowModalJasaSpesialis(!showModalJasaSpesialis)
    setJasaID(row.id)
  }

  const handleClickUpdate = (row) => {
    setVal(row)
    scrollToTop()
  }

  const handleClickDelete = (row) => {
    setJasaID(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData })

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalJasaDokter && (
        <ModalJasaDokter
          setShowModal={() => setShowModalJasaDokter(false)}
          jasaID={jasaID}
        />
      )}

      {showModalJasaSpesialis && (
        <ModalJasaSpesialis
          setShowModal={() => setShowModalJasaSpesialis(false)}
          jasaID={jasaID}
        />
      )}

      <Title title={"Jasa"} />

      <FormJasa
        formData={formData}
        setNewData={setNewData}
        setFormData={setFormData}
        fieldTarif={fieldTarif}
        formHargaTarifBeli={formHargaTarifBeli}
        setFormHargaTarifBeli={setFormHargaTarifBeli}
        resetFormHargaTarifBeli={resetFormHargaTarifBeli}
        formHargaTarifJual={formHargaTarifJual}
        setFormHargaTarifJual={setFormHargaTarifJual}
        resetFormHargaTarifJual={resetFormHargaTarifJual}
        jasaID={jasaID}
        setJasaID={setJasaID}
        dataTarif={dataTarif}
      />

      <div className="mt-2">
        <Paper className={classes.paper}>
          <div className="p-1">
            <Loading show={loading} />
            <FormFilterJasa
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              setNewData={setNewData}
            />

            <TableJasa
              rows={rows}
              dynamicHead={dynamicHead}
              dataTarif={dataTarif}
              handleClickDelete={handleClickDelete}
              handleClickUpdate={handleClickUpdate}
              handleClickSelect={handleClickSelect}
              handleClickSpesialis={handleClickSpesialis}
            />

            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  )
}

const TableJasa = ({
  rows,
  dynamicHead,
  dataTarif,
  handleClickDelete,
  handleClickUpdate,
  handleClickSelect,
  handleClickSpesialis,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: ["nama"],
  })

  return (
    <FreezeTable
      headCells={dynamicHead}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover tabIndex={-1} key={index}>
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>

            <TableCell scope="row" padding="none" align="center">
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <IconButtonDatatable onClick={() => handleClickSpesialis(row)}>
                  <Tooltip title="Mapping Jasa Spesialis" aria-label="add">
                    <AssignmentIndOutlinedIcon
                      style={{
                        fontSize: "18px",
                        color: "#fff",
                      }}
                    />
                  </Tooltip>
                </IconButtonDatatable>

                <TableAction
                  clickUpdate={() => handleClickUpdate(row)}
                  clickDelete={() => handleClickDelete(row)}
                  isSelect={true}
                  clickSelect={() => handleClickSelect(row)}
                />
              </div>
            </TableCell>

            <TableCell align="left">{row?.nama}</TableCell>
            <TableCell align="left">{row?.id_template}</TableCell>
            <TableCell align="left">{row?.kode_snomed}</TableCell>
            <FieldFormTarif dataTarif={dataTarif} row={row} />
            <TableCellDefault row={row} />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={dynamicHead.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}
